import { Download, FileSpreadsheet, Image as ImageIcon } from "lucide-react";
import { API } from "../../lib/api";

const CSV = [
  ["customers", "Customer List"], ["quotes", "Quote History"],
  ["jobs", "Job History"], ["invoices", "Invoice Records"], ["estimates", "Estimates"],
];

export default function ExportPanel() {
  return (
    <div data-testid="export-panel">
      <h2 className="font-display text-2xl font-600 text-charcoal mb-2">Data Export</h2>
      <p className="text-olive mb-6 max-w-2xl">Export your business data anytime. Your records belong to you — never locked into any platform.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CSV.map(([ds, label]) => (
          <a key={ds} href={`${API}/export/${ds}.csv`} data-testid={`export-${ds}`}
            className="flex items-center gap-3 bg-white border border-border rounded-sm p-5 hover:shadow-md hover:-translate-y-0.5 transition-all">
            <span className="grid place-items-center w-10 h-10 rounded-sm bg-emerald/10 text-emerald"><FileSpreadsheet className="w-5 h-5" /></span>
            <div><p className="font-600 text-charcoal">{label}</p><p className="text-xs text-olive">CSV</p></div>
          </a>
        ))}
        <a href={`${API}/export/images.zip`} data-testid="export-images"
          className="flex items-center gap-3 bg-charcoal text-white rounded-sm p-5 hover:opacity-90 transition-opacity">
          <span className="grid place-items-center w-10 h-10 rounded-sm bg-white/15"><ImageIcon className="w-5 h-5" /></span>
          <div><p className="font-600">All Uploaded Images</p><p className="text-xs text-white/70 flex items-center gap-1"><Download className="w-3 h-3" /> ZIP</p></div>
        </a>
      </div>
    </div>
  );
}
